import { PollModuleChild } from '../../modules/polls/router/index';

const route = {
	name: 'survey',
	path: 'survey',
	meta: {
		title: 'Estudios',
	},
	redirect: 'survey/list',
	component: () => import('@/pages/polls/page-survey'),
	children: [
		{
			name: 'survey-list',
			path: 'list',
			component: () => import('@/pages/polls/page-poll'),
			meta: {
				title: 'Listado de Estudios',
			},
			props: true,
			children: [
				{
					name: 'page-polls',
					path: ':id',
					meta: {
						title: 'Resolver Estudio',
					},
					components: {
						pollResolve: () => import('@/pages/polls/page-polls'),
					},
				},
				PollModuleChild,
			],
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/polls/index.js